import React from 'react';
import PropTypes from 'prop-types';
import Translation from '../../../../components/stateless/Translation';

const propTypes = {
  facility: PropTypes.shape({
    surchargeEnabled: PropTypes.bool.isRequired,
    surchargePercentage: PropTypes.number.isRequired,
  }).isRequired,
};

const defaultProps = {};

const FacilitySurchargeBanner = ({ facility }) => {
  if (!facility.surchargeEnabled || !facility.surchargePercentage) {
    return null;
  }

  return (
    <div
      className="mb-4 border-sm-info-blue bg-white p-2 border border-l-8 flex rounded-lg gap-1 w-full relative"
    >
      <div className="pr-2 relative">
        <i className="fa fa-info-circle text-sm-info-blue" aria-hidden="true" />
      </div>
      <div>
        <Translation
          id="enterprise.components.facilitySurchargeBanner"
          defaultMessage="A processing fee of {surchargePercentage} will be added to all credit card payments. No fee for ACH bank transfer."
          values={{
            surchargePercentage: `${facility.surchargePercentage}%`,
          }}
        />
      </div>
    </div>
  );
};

FacilitySurchargeBanner.propTypes = propTypes;
FacilitySurchargeBanner.defaultProps = defaultProps;

export default FacilitySurchargeBanner;
